import { render } from "./StatusPill.vue?vue&type=template&id=42235a7a&scoped=true&ts=true"
import script from "./StatusPill.vue?vue&type=script&lang=ts"
export * from "./StatusPill.vue?vue&type=script&lang=ts"

import "./StatusPill.vue?vue&type=style&index=0&id=42235a7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.27_typescript@5.9.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42235a7a"]])

export default __exports__